import dayjs from "dayjs";

export default function(value) {
  if (!value) return "";
  const format =
    localStorage.getItem("lang") === "fa" ? "YYYY/MM/DD" : "YYYY/DD/MM";
  return dayjs(value).format(format);
}
